import React, { useState } from 'react';
import { Col, Row, Modal, Table, Alert } from 'react-bootstrap';
import { HHIEButton } from '../utility/HHIEButton';
import Loading from '../utility/Loading';

export default function AddUserToRoleModal(props) {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hhieUsers, setHhieUsers] = useState();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);

    const fetchHhieUsers = async () => {
        setLoading(true);
        const userString = sessionStorage.getItem("user");
        if (userString !== null) {
            var sfid = "";
            var user = {};
            try {
                user = JSON.parse(userString);
            }
            catch (ex) {
                console.log("JSONParseUser", ex);
            }
            sfid = user.sfid;
            const users = await fetch('api/user/get-hhie-users-sf/' + sfid)
                .then(async (response) => {
                    try {
                        return await response.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors);
                                return json.message
                            });
                    } catch (ex) {
                        return console.log("GetHhieUsersSF Json error", ex);
                    }
                })
                .catch((ex) => {
                    console.log("GetHhieUsersSF Response error", ex);
                });
            if (users !== null) {
                setHhieUsers(users);
            }
        }
        setLoading(false);

    };
    const handleAddUser = async (selectedUser) => {
        var requestingUserId = "";
        const userString = sessionStorage.getItem("user");
        if (userString !== null) {
            var user = {};
            try {
                user = JSON.parse(userString);
            }
            catch (ex) {
                console.log("JSONParseUser", ex);
            }
            requestingUserId = user.sfid;
        }
        if (requestingUserId === "") {
            setErrorMessage("DEV ERROR: You are not authenticated anymore for this action.");
            setError(true);
            return;
        }

        let sfid = selectedUser.id;
        if (sfid === null || sfid === undefined) {
            setErrorMessage("DEV ERROR: Salesforce Id is blank.");
            setError(true);
            return;
        }

        const formData = new FormData();
        formData.append("sfid", sfid);
        formData.append("role", props.role);
        formData.append("userId", requestingUserId);

        const requestOptions = {
            method: 'POST',
            body: formData
        }
        const result = await fetch('api/user/add-user', requestOptions)
        .then(async (response) => {
            try
            {
                return await response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                        return json.message;
                    });
            }
            catch (ex) 
            {
                setError(true);
                setErrorMessage(ex);
                return console.log("handleAddUser 'add-user' json error", ex);
            }
        })
        .catch(ex => {
            setError(true);
            setErrorMessage(ex);
            console.log("handleAddUser 'add-user' response error", ex);
        });
        
        if (!result) {
            setErrorMessage("Member could not be added to the HHIE " + props.role + " role.");
            setError(true);
        } else {
            setSuccess(result);
            let usersState = [...props.hhieUsers];
            usersState.push(selectedUser);
            props.setHhieUsers(usersState);
        }
    };

    const handleClose = () => {
        if (success) {
            setHhieUsers(null);
        }
        setShow(false);
        setLoading(false);
        setSuccess(false);
        setError(false);
    };

    const handleShow = async () => {
        setShow(true);
        if (!hhieUsers) {
            await fetchHhieUsers();
        }
    };
    const renderTable = (data) => {
        var tableHeader = (<thead>
            <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>SF Role</th>
                <th></th>
            </tr>
        </thead>
        );
        var tableBody = (
            <tbody>
                {data.map(hhieUser => {
                    var fullName = hhieUser.firstName + ' ' + hhieUser.lastName;
                    var role = (hhieUser.role.roleName) ? hhieUser.role.roleName : "N/A";
                    return (
                        <tr key={hhieUser.id}>
                            <td>{fullName}</td>
                            <td style={{ maxWidth: '310px', wordWrap: 'break-word' }}>{hhieUser.email}</td>
                            <td style={(hhieUser.status === 'Inactive') ? {color: 'red'} : {}}>{hhieUser.status}</td>
                            <td>{role}</td>
                            <td>
                                <HHIEButton
                                    title="Add"
                                    noborder="true"
                                    variant="outline-primary"
                                    onClick={() => {handleAddUser(hhieUser);}}
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        );

        return (
            <Row style={{
                // position: 'relative'
            }}>
                <Col style={{
                    padding: '0px'
                    , margin: '7px'
                    , display: 'flex'
                    , alignItems: 'center'
                    , justifyContent: 'center'
                    , height: '100%'
                    , flexDirection: 'column'

                }}>
                    <Table
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                        style={{ maxWidth: '500px' }}
                    >
                        {tableHeader}
                        {tableBody}
                    </Table>
                </Col>
            </Row>
        );
    }
    const modalTitle = "Add to " + props.role + " Role";
    return (
        <>
            <HHIEButton 
                variant="outline-primary" 
                onClick={handleShow} 
                title={modalTitle}
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered
                scrollable
            >
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && <Loading message="Loading please wait. . ." />}
                    {!loading && !success && !error && hhieUsers && renderTable(hhieUsers)}
                    {success && !error && <Alert variant="success">Member added successfully.</Alert>}
                    {!success && error && <Alert variant="danger">{errorMessage}</Alert>}
                </Modal.Body>
                <Modal.Footer>
                    <HHIEButton variant="warning" onClick={handleClose} title="Close"/>
                </Modal.Footer>
            </Modal>
        </>
    );
}